/* global window:false */
import inDOM from 'dom-helpers/util/inDOM';
import { breakpointChanged, breakpointUnchangedAtHydration, REHYDRATED } from '../actions';
import { getCurrentBreakpoint, isBreakpointSet } from '../selectors';
import { current } from '../styles/breakpoints';

export default store => {
  const check = () => {
    const bp = current();
    const state = store.getState();
    const prev = getCurrentBreakpoint(state);
    if (bp !== prev) {
      store.dispatch(breakpointChanged(bp));
    } else if (!isBreakpointSet(state)) {
      store.dispatch(breakpointUnchangedAtHydration());
    }
  };
  if (inDOM) {
    window.addEventListener('resize', check);
  }

  return next => action => {
    const ret = next(action);
    if (action.type === REHYDRATED) {
      check();
    }
    return ret;
  };
};
